import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Media } from '../../../../../theme/Media';
import { Select } from '../../../../Form/Select';
import { dataTableSection } from '../../constants';
import { useTableContext } from '../../context';
import { Info } from '../Info';
import { PageInfo } from '../PageInfo';
import { PaginationControls } from '../PaginationControls';
import { paginationPresetDefault, paginationPresetReduced } from './constants';
import { PageInfoWrapper, PaginationWrapper } from './styled';
export const Pagination = memo(function Pagination({ className, info, pagination, isLoading, dataTestId }) {
    const { compact } = useTableContext();
    const isMobile = useMediaQuery({ query: Media.xsMax });
    const selectedPerPage = useMemo(() => ({ label: String(pagination.perPage), value: pagination.perPage }), [pagination.perPage]);
    const isReducedPaginationPreset = useMemo(() => !!paginationPresetReduced.find((option) => option.value === pagination.perPage), [pagination.perPage]);
    const handleSetPerPage = useCallbackRef((option) => {
        if (option) {
            pagination.setPerPage(option.value);
            pagination.setPage(0);
        }
    });
    const nextPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev + 1);
    });
    const prevPage = useCallbackRef(() => {
        pagination.setPage((prev) => prev - 1);
    });
    if (!isLoading && info.total <= pagination.perPage) {
        return _jsx(Info, { total: info.total, isLoading: isLoading });
    }
    return (_jsxs(PaginationWrapper, { className: className, $compact: compact, ...dataTableSection, "data-testid": dataTestId, children: [!isMobile && (_jsx("div", { "data-testid": 'per-page-dropdown', children: _jsx(Select, { options: isReducedPaginationPreset ? paginationPresetReduced : paginationPresetDefault, value: selectedPerPage, onChange: handleSetPerPage, menuPlacement: 'auto', "data-testid": 'select-op' }) })), _jsx(PageInfoWrapper, { children: _jsx(PageInfo, { dataTestId: 'from-to-total-pagination', ...info, isLoading: isLoading }) }), _jsx(PaginationControls, { page: pagination.page, perPage: pagination.perPage, total: info.total, onPrev: prevPage, onNext: nextPage })] }));
});
export { usePageInfo } from './usePageInfo';
export { usePagination } from './usePagination';
